import trellisLightTheme from './trellis/light/theme';
import trellisDarkTheme from './trellis/dark/theme';
import canvasLightTheme from './canvas/light/theme';

export default {
  ['canvas-light']: canvasLightTheme,
  ['trellis-light']: trellisLightTheme,
  ['trellis-dark']: trellisDarkTheme,
};
